import type { FC } from "react";

import { PlainTooltip } from "@similarweb/ui-components";

import { MultiCountryCell } from "app/components/React/Table/cells/MultiCountryCell";
import { RegionCell } from "app/components/React/Table/cells/RegionCell";

import type { ITableCellProps } from "../interfaces/ITableCellProps";

import { CountryCell } from "./CountryCell";

export const MultiCountryCellWithTooltip: FC<ITableCellProps<readonly number[]>> = (props) => {
    if (props.value.length === 1) {
        if (props.value[0] >= 1000) {
            return (
                <RegionCell
                    {...props}
                    value={props.value[0]}
                />
            );
        }

        return (
            <CountryCell
                {...props}
                value={props.value[0]}
            />
        );
    }

    return (
        <PlainTooltip
            variation="white"
            maxWidth={250}
            tooltipContent={
                <div>
                    {props.value.map((countryCode) => (
                        <CountryCell
                            {...props}
                            value={countryCode}
                            key={countryCode}
                        />
                    ))}
                </div>
            }
        >
            <div>
                <MultiCountryCell {...props} />
            </div>
        </PlainTooltip>
    );
};
